<template>
  <ContactForm :contact="contact" @submit="onSubmit($event)" v-if="!isLoading"></ContactForm>
</template>

<script>
  const dayList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  import ContactService from '../services/contact.service';
  import ContactForm from './ContactForm';

  export default {
    name: 'ContactEdit',
    components: {
      ContactForm,
    },
    data() {
      return {
        isLoading: true,
        contactId: this.$route.params.contact,
        contact: {
          contact_group_id: null,
          name: null,
          email: null,
          sms: null,
          enable_email_baseline: null,
          description: null,
          notif_from: '0000',
          notif_to: '2400',
          notif_day: dayList,
          notif_from_sms: '0000',
          notif_to_sms: '2400',
          notif_day_sms: dayList,
          batch_email: null,
          email_subject_prefix: null,
        },
      };
    },
    mounted() {
      this.getContact();
    },
    methods: {
      onSubmit(event) {
        ContactService.update(this.contactId, event).then(() => {
          this.$router.push('/contact/list');
          this.$showSuccessMessage('Updated Contact');
        });
      },
      async getContact() {
        try {
          this.contact = await ContactService.get(this.contactId);
          this.isLoading = false;
        } catch (error) {
          this.$showErrorMessage('Failed to load Contact');
          this.$router.push('/contact/list');
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
